import { render, staticRenderFns } from "./StepInfo.vue?vue&type=template&id=123674cc&scoped=true&"
import script from "./StepInfo.vue?vue&type=script&lang=js&"
export * from "./StepInfo.vue?vue&type=script&lang=js&"
import style0 from "./StepInfo.vue?vue&type=style&index=0&id=123674cc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123674cc",
  null
  
)

export default component.exports